// MaintenanceRecord GraphQL queries and mutations for 8base
import { gql } from "@apollo/client";

export const MAINTENANCE_LIST = gql`
  query MaintenanceRecordsList {
    maintenanceRecordsList {
      items {
        _description
        cost
        createdAt
        createdBy {
          id
          firstName
          email
          lastName
        }
        description
        id
        performedDate
        scheduledDate
        updatedAt
        maintenanceRecords {
          id
          model
          unitNumber
          status
          updatedAt
          vIN
          year
          licensePlate
          createdAt
        }
      }
    }
  }
`;

export const MAINTENANCE_GET = gql`
  query MaintenanceGet($id: ID!) {
    __typename
    maintenanceRecordsList(filter: { id: { equals: $id } }) {
      items {
        cost
        createdAt
        deletedAt
        description
        performedDate
        scheduledDate
        id
        createdBy {
          id
          firstName
          email
          lastName
        }

        maintenanceRecords {
          id
          model
          make
          unitNumber
          status
          updatedAt
          vIN
          year
          licensePlate
        }
      }
    }
  }
`;

export const MAINTENANCE_CREATE = gql`
  mutation MaintenanceCreate($data: MaintenanceRecordCreateInput!) {
    maintenanceRecordCreate(data: $data) {
      id
    }
  }
`;

export const MAINTENANCE_UPDATE = gql`
  mutation MaintenanceUpdate($data: MaintenanceRecordUpdateInput!) {
    maintenanceRecordUpdate(data: $data) {
      id
    }
  }
`;

export const MAINTENANCE_DELETE = gql`
  mutation MaintenanceRecordDestroy($filter: InsurancePolicyKeyFilter!) {
    maintenanceRecordDestroy(filter: $filter) {
      success
    }
  }
`;
